<template>
  <footer class="app-footer">
    <div class="footer-content">
      <p>&copy; {{ currentYear }} Nordeus. All rights reserved. / Device Tracker - Internal Use Only</p>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { COLORS, FONTS } from '@/styles/brand'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.app-footer {
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px 32px;
  text-align: center;
  position: relative;
  z-index: 100;
  margin-top: auto;
}

.footer-content p {
  color: rgba(255, 255, 255, 0.8);
  margin: 2px 0;
  font-size: 0.9rem;
  font-family: v-bind('FONTS.GOOGLE');
}
</style>
